exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v3XO21lbF2KTJmfBkP6aN .save-buttons .save{background-color:dycolor-internal(!button-background,@primary)}\n", ""]);

// exports
exports.locals = {
	"root": "v3XO21lbF2KTJmfBkP6aN"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true!./~/gotu-vue-dycolor/dist/lib/dycolor-loader.js?colors!./~/sass-loader/lib/loader.js?outputStyle=compressed!./src/components/lab/creative-external-previews/CreativeExternalPreviews.scss
// module id = 889
// module chunks = 1